import React from "react";
import "./GetMusicOnGracenote.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnGracenote = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music catalog",
    "Submit metadata for Gracenote",
    "Music indexed globally",
    "Recognized across devices & platforms",
    "Improve discovery & visibility worldwide"
  ];

  return (
    <>
      <Helmet>
        <title>
          Gracenote Music Data Distribution | Music Metadata & Discovery | FT Tunes
        </title>

        <meta
          name="description"
          content="Deliver accurate music metadata and improve global music discovery with Gracenote via FT Tunes. Power recognition across streaming, TV, and connected devices."
        />

        <meta
          name="keywords"
          content="Gracenote distribution, music metadata delivery, Gracenote music data, music discovery platform, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="gracenote-page">

        {/* HERO */}
        <section className="gracenote-hero">
          <Container>

            <img
              src="/Images/gracenote-logo.png"
              alt="Gracenote"
              className="gracenote-logo"
            />

            <h1>Deliver Music Data with Gracenote</h1>

            <p>
              Power music discovery worldwide with Gracenote’s
              industry-leading metadata and recognition technology.
              Ensure your music is identified across streaming,
              TV, automotive systems, and connected devices.
            </p>

            <Button
              className="gradient-btn-gracenote"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-gracenote"></div>
        </section>


        {/* SHOWCASE */}
        <section className="gracenote-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Global Music Recognition</h2>

                <p>
                  Gracenote enriches your music with high-quality
                  metadata used by streaming services, broadcasters,
                  smart TVs, vehicles, and voice assistants worldwide.
                </p>

                <Button
                  className="outline-btn-gracenote"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-gracenote.png"
                  alt="Get Your Music on Gracenote"
                  className="gracenote-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="gracenote-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-gracenote">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="gracenote-benefits">
          <Container>

            <h2 className="section-title">
              Why Use Gracenote
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-gracenote">
                  <h5>Global Discovery</h5>
                  <p>Improve visibility across platforms.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-gracenote">
                  <h5>Metadata Accuracy</h5>
                  <p>Industry-standard music information.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-gracenote">
                  <h5>Device Recognition</h5>
                  <p>Recognized on TV, cars & smart devices.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-gracenote">
                  <h5>Better Recommendations</h5>
                  <p>AI-driven music discovery systems.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="gracenote-cta">
          <Container>

            <h2>Make Your Music Discoverable Everywhere</h2>

            <Button
              className="gradient-btn-gracenote big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnGracenote;